import React, { useMemo } from 'react';
import { useAllowedActions } from 'utils';
import { SidebarNav } from 'design-system';
import Footer from './Footer';
import configNavMenuRoutes from '../../config/navMenu';
import { useAuth0 } from '@auth0/auth0-react';

const Layout = ({ children }) => {
	const { logout, user } = useAuth0();
	const { allowedActions } = useAllowedActions();
	const menuItems = useMemo(() => configNavMenuRoutes(allowedActions), [allowedActions]);
	return (
		<React.Fragment>
			<div id='layout-wrapper'>
				<SidebarNav
					navMenu={menuItems}
					onLogout={logout}
					profile={user}
				/>
				<div className='main-content'>
					{children}
					<Footer />
				</div>
			</div>
		</React.Fragment>
	);
};

export default Layout;
